/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type reportedTimeTable_viewer = {
    readonly id: string;
    readonly company: {
        readonly totalMinutesRegistered: number | null;
        readonly currency: string | null;
    } | null;
    readonly " $refType": "reportedTimeTable_viewer";
};
export type reportedTimeTable_viewer$data = reportedTimeTable_viewer;
export type reportedTimeTable_viewer$key = {
    readonly " $data"?: reportedTimeTable_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"reportedTimeTable_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery",
      "type": "TaskSearchQueryType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "reportedTimeTable_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            }
          ],
          "kind": "ScalarField",
          "name": "totalMinutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '08f30e5bb4510e6dcfd81211db47d7b7';
export default node;
